module.exports = __webpack_public_path__ + "assets/img/settlement3.5debe161.png";